module.exports = __webpack_public_path__ + "img/logo.06f3b29f.png";